import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { LimitedOptionsFlow, OtherTopicFlow } from '../../../pageFlowData'
import { otherTopicData } from './data'

export const OtherTopic: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, OtherTopicFlow.VIEW_NAME, { id, index })
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_OTHER_TOPIC', data: id })
    dispatch({ type: 'UPDATE_STEP', data: LimitedOptionsFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: LimitedOptionsFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = otherTopicData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage buttons={buttons} handleSubmit={handleSubmit} imgObj={imgObj} title={title} />
    </div>
  )
}
